
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { PatentClaimService } from '../patent-claim-service';
import {type ClaimNode, PatentClaimApi} from '@telecom/shared/infrastructure/api-functions/patent-claim-api';

@injectable()
export class PatentClaimServiceImpl implements PatentClaimService {
    constructor(
        @inject(PatentClaimApi)
        private readonly _patentClaimApi: PatentClaimApi,
    ) {}
    getPatentClaim(payload: {patentId: string ,lang: string}): Promise<string> {
        return this._patentClaimApi.getPatentClaim(payload);
    }

    async getPatentClaimsTree(patentId: string): Promise<ClaimNode[]> {
        const res = await this._patentClaimApi.getPatentClaimsTree(patentId);
        return res?.claims?.CLMS_TREE || [];
    }
}
